import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppFlexModule } from '../flex/index.js';
import { IconModule } from '../icons/index.js';
import { TooltipMenuItemComponent } from './tooltip-menu-item.component.js';
import { TooltipMenuComponent } from './tooltip-menu.component.js';
import { TooltipMenuDirective } from './tooltip-menu.directive.js';
import { TooltipDirective } from './tooltip.directive.js';
import { ImagesModule } from 'lib/images/images.module.js';
import { LinkModule } from "../link/link.module.js";

@NgModule({
    declarations: [TooltipDirective, TooltipMenuDirective, TooltipMenuComponent, TooltipMenuItemComponent],
    exports: [TooltipDirective, TooltipMenuDirective, TooltipMenuComponent, TooltipMenuItemComponent],
    imports: [CommonModule, RouterModule, AppFlexModule, IconModule, ImagesModule, LinkModule]
})
export class TooltipModule {}
